(function () {
  function init(section) {
    const id = section.getAttribute('data-section-id');
    const input = document.getElementById(`cafc-${id}-search`);
    const result = document.getElementById(`cafc-${id}-result`);
    const clearBtn = document.getElementById(`cafc-${id}-clear`);
    const list = document.getElementById(`cafc-${id}-suggestions`);

    if (!input || !result || !clearBtn || !list) return;

    const dayMap = {
      Tuesday: [
        "Boston",
        "Brighton",
        "Brookline",
        "Cambridge",
        "Canton",
        "Charlestown",
        "Chelsea",
        "Dedham",
        "Dorchester",
        "Everett",
        "Hyde Park",
        "Jamaica Plain",
        "Malden",
        "Medford",
        "Melrose",
        "Milton",
        "Norwood",
        "Revere",
        "Roxbury",
        "Saugus",
        "Somerville",
        "West Roxbury",
        "Winthrop"
      ],

      Wednesday: [
        "Acton",
        "Arlington",
        "Auburndale",
        "Ayer",
        "Bedford",
        "Belmont",
        "Billerica",
        "Bolton",
        "Boxborough",
        "Burlington",
        "Carlisle",
        "Chelmsford",
        "Concord",
        "Framingham",
        "Groton",
        "Harvard",
        "Lexington",
        "Lincoln",
        "Littleton",
        "Maynard",
        "Natick",
        "Needham",
        "Newton",
        "Reading",
        "Stoneham",
        "Stow",
        "Sudbury",
        "Waban",
        "Wakefield",
        "Waltham",
        "Watertown",
        "Wayland",
        "Wellesley",
        "Westford",
        "Weston",
        "Wilmington",
        "Winchester",
        "Woburn"
      ],

      Thursday: [
        "Amesbury",
        "Andover",
        "Beverly",
        "Boxford",
        "Byfield",
        "Danvers",
        "Essex",
        "Georgetown",
        "Gloucester",
        "Groveland",
        "Hamilton",
        "Ipswich",
        "Lynn",
        "Lynnfield",
        "Manchester",
        "Manchester by the Sea",
        "Marblehead",
        "Middleton",
        "Newbury",
        "Newburyport",
        "North Reading",
        "Peabody",
        "Rockport",
        "Rowley",
        "S Hamilton",
        "Salem",
        "Salisbury",
        "Swampscott",
        "Topsfield",
        "Wenham",
        "West Newbury"
      ]
    };

    const townAliases = {
      "jp": "Jamaica Plain",
      "jamaica plain ma": "Jamaica Plain",
      "west roxbury ma": "West Roxbury",
      "manchester-by-the-sea": "Manchester by the Sea",
      "manchester by-the-sea": "Manchester by the Sea",
      "manchester by sea": "Manchester by the Sea",
      "south hamilton": "S Hamilton",
      "s. hamilton": "S Hamilton",
      "north reading ma": "North Reading"
    };

    const townToDay = {};
    const displayNames = {};

    Object.entries(dayMap).forEach(([day, towns]) => {
      towns.forEach((town) => {
        const normalizedTown = normalizeTown(town);
        townToDay[normalizedTown] = day;
        displayNames[normalizedTown] = town;
      });
    });

    Object.entries(townAliases).forEach(([alias, officialTown]) => {
      const officialKey = normalizeTown(officialTown);
      const aliasKey = normalizeTown(alias);

      if (townToDay[officialKey]) {
        townToDay[aliasKey] = townToDay[officialKey];
        displayNames[aliasKey] = officialTown;
      }
    });

    function normalizeTown(value) {
      return String(value || "")
        .toLowerCase()
        .trim()
        .replace(/,/g, " ")
        .replace(/\bmassachusetts\b/g, "")
        .replace(/\bma\b/g, "")
        .replace(/[.-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function setResult(town, day) {
      if (day) {
        result.innerHTML =
          `<strong>${escapeHtml(town)}</strong> → ` +
          `<span>${escapeHtml(day)}</span> ` +
          `<span class="tag">Home Delivery</span>`;
      } else {
        result.textContent = town;
      }
    }

    function showSuggestions(matches) {
      list.innerHTML = "";
      activeIndex = -1;

      if (!matches.length) {
        list.style.display = "none";
        return;
      }

      matches.slice(0, 8).forEach((town, index) => {
        const li = document.createElement("li");

        li.textContent = town;
        li.setAttribute("role", "option");
        li.setAttribute("id", `cafc-${id}-option-${index}`);
        li.setAttribute("aria-selected", "false");

        li.addEventListener("click", () => {
          input.value = town;
          handleLookup();
          list.style.display = "none";
        });

        list.appendChild(li);
      });

      list.style.display = "block";
    }

    function getOfficialTowns() {
      const towns = [];

      Object.values(dayMap).forEach((dayTowns) => {
        dayTowns.forEach((town) => {
          if (!towns.includes(town)) {
            towns.push(town);
          }
        });
      });

      return towns;
    }

    function handleLookup() {
      const rawValue = input.value || "";
      const query = normalizeTown(rawValue);

      if (!query) {
        result.textContent = "";
        clearBtn.style.display = "none";
        list.style.display = "none";
        return;
      }

      clearBtn.style.display = "block";

      if (townToDay[query]) {
        const officialTown = displayNames[query] || rawValue.trim();
        setResult(officialTown, townToDay[query]);
        showSuggestions([]);
        return;
      }

      const officialTowns = getOfficialTowns();

      const startsWithMatches = officialTowns.filter((town) =>
        normalizeTown(town).startsWith(query)
      );

      const containsMatches = officialTowns.filter((town) => {
        const normalizedTown = normalizeTown(town);

        return (
          !normalizedTown.startsWith(query) &&
          normalizedTown.includes(query)
        );
      });

      const aliasMatches = Object.entries(townAliases)
        .filter(([alias]) => normalizeTown(alias).includes(query))
        .map(([, officialTown]) => officialTown);

      const suggestions = [
        ...new Set([
          ...startsWithMatches,
          ...containsMatches,
          ...aliasMatches
        ])
      ];

      if (suggestions.length) {
        setResult("Did you mean one of these?", null);
        showSuggestions(suggestions);
      } else {
        setResult(
          "No match found. Try another spelling or a nearby town.",
          null
        );
        showSuggestions([]);
      }
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (character) => {
        const characters = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        };

        return characters[character];
      });
    }

    input.addEventListener("input", handleLookup);
    input.addEventListener("focus", handleLookup);

    clearBtn.addEventListener("click", () => {
      input.value = "";
      handleLookup();
      input.focus();
    });

    let activeIndex = -1;

    input.addEventListener("keydown", (event) => {
      const items = Array.from(list.querySelectorAll("li"));

      if (!items.length) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = (activeIndex + 1) % items.length;
        updateActive(items);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex =
          (activeIndex - 1 + items.length) % items.length;
        updateActive(items);
      } else if (event.key === "Enter") {
        if (activeIndex >= 0 && items[activeIndex]) {
          event.preventDefault();
          items[activeIndex].click();
        }
      } else if (event.key === "Escape") {
        list.style.display = "none";
        activeIndex = -1;
      }
    });

    function updateActive(items) {
      items.forEach((item, index) => {
        item.setAttribute(
          "aria-selected",
          index === activeIndex ? "true" : "false"
        );
      });

      if (items[activeIndex]) {
        items[activeIndex].scrollIntoView({
          block: "nearest"
        });
      }
    }

    const params = new URLSearchParams(window.location.search);
    const townParameter = params.get("town");

    if (townParameter) {
      input.value = townParameter;
      handleLookup();
    }
  }

  function onLoad() {
    document
      .querySelectorAll(".cafc-delivery-finder")
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onLoad);
  } else {
    onLoad();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.matches(".cafc-delivery-finder")
      ? event.target
      : event.target.querySelector(".cafc-delivery-finder");

    if (section) {
      init(section);
    }
  });

  document.addEventListener(
    "click",
    (event) => {
      const summary = event.target.closest(
        ".cafc-full-list > summary"
      );

      if (!summary) return;

      const details = summary.parentElement;

      setTimeout(() => {
        if (
          typeof details.open === "undefined" ||
          (
            summary.getAttribute("aria-expanded") &&
            summary.getAttribute("aria-expanded") === "false"
          )
        ) {
          details.open = !details.open;
        }
      }, 0);
    },
    true
  );
})();